import { FormlyFieldConfig } from '@ngx-formly/core';

export class NonOwnerPersonnelFormFields {

  constructor() {}

  nonOwnerPersonnelFields(): FormlyFieldConfig[] {
    return [
      {
        fieldGroupClassName: 'formly-column',
        fieldGroup: [
          {
            className: 'formly-column-left',
            fieldGroup: [
              { // BEGIN First Name, Last Name, Title, Mobile Phone, Work Phone, & Email
                fieldGroupClassName: 'formly-field-group',
                fieldGroup: [
                  {
                    key: 'first',
                    type: 'text',
                    templateOptions: {
                      label: 'First Name',
                      attributes: {
                        'data-cy': 'first-name-input'
                      },
                        required: true,
                    },
                    validation: {
                      show: true,
                    }
                  },
                  {
                    key: 'last',
                    type: 'text',
                    templateOptions: {
                      label: 'Last Name',
                      attributes: {
                        'data-cy': 'last-name-input'
                      },
                      required: false
                    },
                    validation: {
                      show: true,
                    }
                  },
                  {
                    key: 'title',
                    type: 'text',
                    templateOptions: {
                      label: 'Title/Role',
                      attributes: {
                        'data-cy': 'title-input'
                      }
                    }
                  },
                  { // BEGIN Mobile Phone, Work Phone, & Email
                    fieldGroupClassName: 'formly-field-group',
                    fieldGroup: [
                      {
                        fieldGroup: [
                          {
                            key: 'mobilePhoneModel',
                            type: 'intl-phone',
                            templateOptions: {
                              label: 'Mobile Phone',
                              attributes: {
                                'data-cy': 'mobile-phone-input'
                              }
                            }
                          }
                        ]
                      },
                      {
                        fieldGroup: [
                          {
                            key: 'workPhoneModel',
                            type: 'intl-phone',
                            templateOptions: {
                              label: 'Work Phone',
                              attributes: {
                                'data-cy': 'work-phone-input'
                              }
                            }
                          }
                        ]
                      },
                      {
                        key: 'email',
                        type: 'text',
                        templateOptions: {
                          label: 'Email',
                          attributes: {
                            'data-cy': 'email-input'
                          },
                          pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
                          required: false
                        },
                        validation: {
                          show: true,
                        }
                      }
                    ]
                  }
                ]
              } // END First Name, Last Name, Title, Mobile Phone, Work Phone, & Email
            ]
          }
        ]
      }
    ];
  }
}
